import { useState } from 'react';

/**
 * Custom hook to manage show more/less functionality for lists
 * @param {Array} items - The array of items to show/hide
 * @param {number} initialCount - The initial number of items to display
 * @returns {Object} - Object containing visible items, counts, labels, and toggle handler
 */
export function useShowMoreLess(items = [], initialCount = 0) {
  const [showMore, setShowMore] = useState(false);

  const itemsToShow = showMore ? items.length : initialCount;
  const visibleItems = items.slice(0, itemsToShow);
  const hiddenCount = items.length - initialCount;
  const toggleLabel = showMore ? '- Show Less' : `+ Show ${hiddenCount} More`;
  const shouldShowToggle = items.length > initialCount;

  const handleToggle = (event) => {
    event.preventDefault();
    setShowMore(!showMore);
  };

  return {
    visibleItems,
    hiddenCount,
    toggleLabel,
    handleToggle,
    showMore,
    shouldShowToggle
  };
}
